WiseMetering.Views.DestroyCompany = WiseMetering.Views.Modal.Destroy.extend({
    title: () => i18next.t('modal.title.companies.destroy')
});
